const SetFormat = (num) => {
  let number = 0;
  const regexReplace = {
    splitBy4: (num) => {
      try {
        num = num.toString().replace(/\d{4}/g, ($1) => `${$1} `);

        return num;
      } catch {
        return 0;
      }
    },
    onlyInt: (num) => {
      try {
        num = num
          .toString()
          .replace(/[\u0660-\u0669]/g, (c) => c.charCodeAt(0) - 0x0660)
          .replace(/[\u06f0-\u06f9]/g, (c) => c.charCodeAt(0) - 0x06f0)
          .replace(/\D/g, "");

        // remove leading zeros
        num = num.toString().replace(/^0+/, "");

        return num;
      } catch {
        return 0;
      }
    },
    commaSeparated: (num) => {
      try {
        num = num.toString().split(".");
        num[0] = num[0].toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

        return num.join(".");
      } catch {
        return null;
      }
    },
  };

  number = regexReplace.commaSeparated(num);
  return number;
};
export { SetFormat };
